// extracted by mini-css-extract-plugin
export default {"metaData":"metaData--IeQ7N","left":"left--Gffwr","right":"right--EiHTs","xSplit":"xSplit--IJSns"};